// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"75a88b73","149":"b5447772","493":"32654b36","636":"676eee0d","649":"5fa8e150","653":"c4a6154a","677":"338df0cc","760":"beaa8e0f","780":"27c973e8","836":"7ac653bb","847":"bdabdced","953":"3ff3d23d","985":"3bb5e536","988":"6a8391ff"}[chunkId] + ".chunk.js";
};